// src/components/ads/SectionChangeEvents.tsx
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { trackEvent } from '../../lib/analytics'
import { readAdsOffFlag } from '../../lib/ads'
import { sectionOf } from '../../lib/section'

/** Sends one `section_changed` event per client-side move between sections.
 *  Renders nothing. Measures how often a session would reload ads if section
 *  switches became full page loads (the decision that needs it, 2026-10-15).
 *  The landing route is not an event: session_start already carries
 *  landing_path. `ads_off` is the cached Pro flag, so Pro sessions
 *  can be excluded from the read. Same StrictMode guard as GA4PageViews. */
export default function SectionChangeEvents() {
  const { pathname } = useLocation()
  const last = useRef<string | null>(null)
  useEffect(() => {
    const section = sectionOf(pathname)
    const from = last.current
    last.current = section
    if (from === null || from === section) return
    trackEvent('section_changed', { from_section: from, to_section: section, ads_off: readAdsOffFlag() })
  }, [pathname])
  return null
}
